import React from 'react';
import './Divider.css';

const Divider = () => {
    return <hr className="sidebar-divider" />;
};

export default Divider;
